const lvPostcode = (value) => {
  const pattern = /^LV-\d{4}$/;
  
  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', 'LV-0000'];
  }
};

export default lvPostcode;
